import Keyboard from 'simple-keyboard'

function isLetter(c) {
  return c.toLowerCase() != c.toUpperCase();
}

const state = {
  keyboard: null,
  layout: {
    default: [
      "Q W E R T Y U I O P",
      "A S D F G H J K L",
      "{shift} Z X C V B N M {backspace}",
    ],
  },
}

const getters = {}

// { direction:string, clueNumber:number, clue:string }
const actions = {
  // letters = an array of letters
  // row total rows to split the keyboard up with
  setLayout({ commit, state }, {rows, letters, vertical = true, name = 'default'}) {
    // function isLetter(c) {
    //   return c.toLowerCase() != c.toUpperCase();
    // }
    let layout = []

    if (!vertical)
      rows = Math.ceil(letters.length / rows)

    for (let i = 0; i < letters.length; i += rows) 
    {
      let row = []

      for (let j = i; j < i + rows; j++)
      {
        const letter = letters[j]
        if (letter) row.push(letters[j])
      }

      layout.push(row.join(' '))
    }

    layout.push('{backspace}')

    commit('SET_LAYOUT', {layout, name})
  },
  
  switchLayout({ state }, name) {    
    state.keyboard.setOptions({
      layoutName: name
    })
  },
  
  createKeyboard({commit, dispatch}) {    
    commit('SET_KEYBOARD', key => dispatch('onKeyPress', key))
  },

  onKeyPress({rootState, dispatch}, key) {
    if (!rootState.grid.selectedCell) return

    let payload = {
      row: rootState.grid.selectedCell.row, 
      col: rootState.grid.selectedCell.col,
      input: key.toUpperCase(),
    }

    dispatch('grid/keyPress', payload, {root: true})
    
  },

  disableKey({state, commit}, key)
  {
    if (!isLetter(key)) return

    let elem = state.keyboard.getButtonElement(key.toUpperCase())
    if (elem)
    {
      elem.classList.add('disabled')
    }
  },

  enableKey({state, commit}, key)
  {
    if (!isLetter(key)) return
    
    let elem = state.keyboard.getButtonElement(key.toUpperCase())
    if (elem)
    {
      elem.classList.remove('disabled')
    }
  },

  incorrectKey({state, rootState}, key)
  {
    if (!isLetter(key)) return

    let elem = state.keyboard.getButtonElement(key.toUpperCase())
    if (elem)
    {
      if(rootState.userSettings.gameMode === 'quick')
        elem.classList.add('incorrect')
      else
        elem.classList.add('challenged-used')
    }
  },

  correctKey({state, rootState}, key)
  {
    if (!isLetter(key)) return

    let elem = state.keyboard.getButtonElement(key.toUpperCase())
    if (elem)
    {
      if(rootState.userSettings.gameMode === 'quick')
        elem.classList.add('used')
      else
        elem.classList.add('challenged-used')
    }
  },

  removeKeyStyles({state, commit}, key)
  {
    if (!isLetter(key)) return

    let elem = state.keyboard.getButtonElement(key.toUpperCase())
    if (elem)
    {
      elem.classList.remove('used')
      elem.classList.remove('incorrect')
      elem.classList.remove('challenged-used')
    }
  },

  challengeKey({state, rootState}, key)
  {
    if (!isLetter(key)) return

    let elem = state.keyboard.getButtonElement(key.toUpperCase())
    if (elem)
    {
      if(rootState.userSettings.gameMode === 'quick')
        elem.classList.add('used')
      else
        elem.classList.add('disabled')
    }
  },

}

const mutations = {
  SET_KEYBOARD(state, cb) {
    // state.keyboard
    state.keyboard = new Keyboard({
      onChange: null,
      onKeyPress: cb,
      layout: state.layout,
      display: {
        '{backspace}': '⌫',
        '{shift}': '↪',//'🗘',
      }
    })
  },

  SET_LAYOUT(state, {layout, name}) {
    state.layout[name] = layout
    // state.keyboard.setOptions({ layout: { default: layout } })
  },

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}